import { iTradeEnv } from '@/configurations/app-configs/iTrade.env'

const PATH_CONSTANTS = {
  HOME: '/',
  TRADE: '/trade',
  ABOUT_US: '/about-us',
  MARKET_DATA: '/market',
  PLACE_ORDER: '/place-order',
  ACCOUNT_DATA: '/my-account',
  FORUM: '/forum',
  FORUM_DETAIL: '/forum-detail',
  VIRTUAL: '/virtual-trading',
  LOGIN: '/login',
  REGISTER: '/register',
  IPO: '/ipo',
  CA: '/corp-action',
  FORGOT_PW: '/forgot-password',
  CHANGE_PW: '/change-password',
  ACCOUNT_DATA_PORTFOLIO: '/my-account/portofolio',
  FUND_MANAGEMENT: '/fund-management',
  E_STATEMENT:'/e-statement',
  E_MESSAGE: '/e-message',
  CHECK_AUTH: '/checkauth',
  MORE_TAB: '/more-tab',
  RESET_PW: '/reset-password',
  BCAN: '/bcan',
  IPRESTRICTED: '/ip-restricted'
}

export const PATH = Object.entries(PATH_CONSTANTS).reduce((prev, next) => (prev[next[0]] = [iTradeEnv.routerPrefix, next[1]].join(''), prev), {})